{
  "validation.maxAttachments": "Es können maximal {{max}} Anhänge hochgeladen werden.",
  "validation.minAttachments": "Es werden mindestens {{min}} Anhänge benötigt.",
  "validation.maxAttachmentSize": "Anhänge können maximal {{max}} Megabyte groß sein.",
  "validation.attachmentListItemRequired": "Bitte häng eine Datei für \"{{category}}\" an.",
  "validation.attachmentListItemMaxAttachments": "Es dürfen nur {{max}} Anhänge in  \"{{category}}\" hochgeladen werden.",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}}-Anhänge dürfen nicht größer als {{max}} Megabyte sein.",
  "attachment.bsoCategory.DiagnosticReport": "Diagnosebericht",
  "attachment.bsoCategory.InvoiceDocument": "Rechnungsdokument",
  "attachment.bsoCategory.ShippingDocument": "Versanddokument",
  "attachment.bsoCategory.Letter": "Brief",
  "attachment.bsoCategory.PictureReference": "Bildreferenz",
  "attachment.bsoCategory.BugReport": "Fehlerbericht",
  "attachment.bsoCategory.Other": "Sonstige",
  "attachment.bsoCategory.Unclassified": "Nicht klassifiziert",
  "attachment.bsoCategory.ServiceForms": "Serviceformular",
  "attachment.bsoCategory.RegistrationDocument": "Registrierungsdokument",
  "attachment.bsoCategory.ShopInside": "Foto vom Ladeninneren",
  "attachment.bsoCategory.ShopImageMigration": "ShopImage Migration",
  "attachment.bsoCategory.ShopImage": "Foto von der Ladenfront",
  "attachment.uploadButton": "{{category}} Hochladen",
  "attachment.uploadDropdown": "Datei hochladen"
}